import { yearCounter } from '../utils/dateSettings';

export const copy = {
	description: `COPYRIGHT &copy; ${yearCounter} &#38; created by EMBIQ. All product and trademarks &trade; or registered &reg; trademarks of their respective holders. Use of them does not imply affiliation or endorsement by them.`,
};

export const address = {
	title: 'Kontakt',
	addressPL: 'EMBIQ Sp. z o.o. , Gęsia 5, 20-719 Lublin, Polen',
	addressAT: 'EMBIQ GmbH, Brückenkopfgasse 1/6, 8020 Graz, Austria',
	phonePL: '+48 81 561 85 01',
	phoneAT: '+43 316 23 100 055',
};
